import {useQuery} from 'react-query'
import {parseISO} from 'date-fns'

import {api, queryClient, useMutationQuery, LONG_STALE_QUERY_TIME} from 'base'
import {NotificationsCategory} from 'common/types'

export const useGetNotifications = (read: boolean = false, enabled?: boolean) =>
  useQuery<any>(
    ['notifications', read ? 'read' : 'unread'],
    async () => {
      const {data} = await api.get('/userNotification/list', {
        params: {
          filter: {
            read: read ? true : undefined,
            unread: read ? undefined : true,
          },
        },
      })
      const sortedData: any[] = data.data.slice()
      sortedData.sort((a, b) => +parseISO(b.createdAt) - +parseISO(a.createdAt))
      return sortedData
    },
    {enabled, refetchInterval: LONG_STALE_QUERY_TIME}
  )

export const useReadNotification = (notificationUuid: string) =>
  useMutationQuery<any>(
    ['readNotification', notificationUuid],
    async () => {
      const {data} = await api.post(
        `/userNotification/${notificationUuid}/read`
      )
      return data.data
    },
    {
      onSuccess() {
        queryClient.setQueriesData(
          ['notifications', 'unread'],
          (oldData: any[]) => {
            const newData = oldData.filter(
              (notification) => notification.uuid !== notificationUuid
            )
            return newData
          }
        )
        queryClient.invalidateQueries('notifications')
      },
    }
  )

export const useReadNotificationsCategory = (category: NotificationsCategory) =>
  useMutationQuery<any, any, string[]>(
    ['readNotificationsCategory', category],
    async (notifications) => {
      const {data} = await api.post(`/userNotification/read`, {notifications})
      return data.data
    },
    {
      onSuccess() {
        /* queryClient.setQueriesData(
          ['notifications', 'unread'],
          (oldData: any[]) => {
            const newData = oldData.filter(
              (notification) => notification.uuid !== notificationUuid
            )
            return newData
          }
        ) */
        queryClient.invalidateQueries('notifications')
      },
    }
  )

export const useGetConditions = () =>
  useQuery<any>('conditions', async () => {
    const {data} = await api.get('projectCondition/list', {
      params: {
        include: 'project',
      },
    })
    const sortedFilteredData: any[] = data.data.filter(
      (item: any) => !item.checkedDate
    )
    sortedFilteredData.sort((a, b) => +parseISO(a.date) - +parseISO(b.date))
    return sortedFilteredData
  })
